import React from 'react';
import { List, InputItem } from 'antd-mobile';
// const Item = List.Item;

function MyInfo() {
  return (
    <div>
      <List>
        <InputItem placeholder="请输入姓名">名称</InputItem>
      </List>
    </div>
  );
}

export default MyInfo;
